// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"64":"6ffa9bd2","84":"f5af5f49","245":"6ffa9bd2","473":"6ffa9bd2","874":"6ffa9bd2","892":"6ffa9bd2","917":"6ffa9bd2"}[chunkId] + ".chunk.css";
};